export default {
    module: [],
}